module.exports = __webpack_public_path__ + "img/090-storm-1.ee3bd1ac.svg";